﻿import axios from "axios";
import { ACCESS_TOKEN_KEY } from "features/Authentication/store/login/reducer";
import { toast } from "react-toastify";

const axiosClient = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}`,
});

function logAxiosError(error: unknown) {
  if (axios.isAxiosError(error)) {
    const { config, response, message } = error;
    const url = [config?.baseURL, config?.url].filter(Boolean).join("");
    const method = config?.method?.toUpperCase() ?? "REQUEST";
    console.error(
      `[axios] ${method} ${url}`,
      response
        ? {
            status: response.status,
            statusText: response.statusText,
            data: response.data,
          }
        : { message: message || "Network error (no response)" },
      error,
    );
    return;
  }
  console.error("[axios] Non-Axios error:", error);
}

axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(ACCESS_TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    logAxiosError(error);

    const status = error.response?.status;
    const reqUrl = String(error.config?.url ?? "");
    const isPublicAuthFailure =
      status === 401 &&
      (reqUrl.includes("/auth/login") ||
        reqUrl.includes("/auth/forgot-password") ||
        reqUrl.includes("/auth/reset-password"));

    if (status === 401 && !isPublicAuthFailure) {
      toast.error("Session expired. Please login again.");
      localStorage.removeItem(ACCESS_TOKEN_KEY);
      window.location.replace("/login");
    }

    // if (status === 403) {
    //   toast.error("You are not authorized to access this resource.");
    //   window.location.replace("/unauthorized");
    // }

    return Promise.reject(error);
  },
);

export default axiosClient;
